module.exports = __webpack_public_path__ + "img/logoY.2ae3929d.png";